<template>
  <div class="process-container">
      <div class="schedule">
      <p class="title">{{$t('top.common.sitesRanking')}}</p>
      <a href="javascript:void(0);" class="check-more"
      @click="drawer = true"
        >{{$t('top.common.showMore')}}<span class="check-icon"></span
      ></a>
    </div>
    <div class="rank-progress">
      <div class="rank-content" v-if="centerProgressSizeDtoList && centerProgressSizeDtoList.length">
        <div v-for="(item,index) in centerProgressSizeDtoList" :key="index">
           <div class="rank-item" >
              <el-popover
                v-if="sliceStr(store.lang === 'zh_CN'?item.info:'')"
                placement="bottom-start"
                width="300"
                trigger="hover"
                :ref="'popover'+index"
                :content="sliceStr(store.lang === 'zh_CN'?item.info:'')"
                >
              </el-popover>
              <div class="item-left" :style="store.lang !== 'zh_CN'&& 'cursor:revert'" @click="showCenter(item)" v-popover="'popover'+index">
                  <div class="item-left-top">
                    <span class="item-name">{{store.lang === 'zh_CN'?item.progressName:item.progressNameEn}}</span>
                    <p class="item-data">
                      <span>{{item.patientSize}}</span>
                    </p>
                  </div>
                  <el-progress
                    color='#2194FE'
                    :percentage="Math.round(item.patientSize/maxNum*100)"
                    :stroke-width="5"
                    :show-text="false"
                  ></el-progress>
                </div>
              <div :class="['item-right',store.lang === 'zh_CN'?'item-right-ch':'item-right-en']" @click="showPI(item)" v-if="item.pi">
                <el-avatar class="item-right-photo" fit="fill" :size="21" :src="item.pi.length >1?'':item.pi[0].avatar">
                  <img src="@/assets/image/photo.png"/>
                </el-avatar>
                <span class="item-right-name">{{item.pi.length >1?$t('top.common.investigator'):(store.lang === 'zh_CN'?item.pi[0].realName:item.pi[0].realNameEn)}}</span>
              </div>
              <div v-else class="item-right"></div>
          </div>
        </div>
      </div>
    </div>
    <el-drawer
      :title="$t('top.common.sitesRanking')"
      :visible.sync="drawer"
      direction="rtl"
      size="60%"
      >
      <div class="rank-progress rank-progress-large">
        <div class="rank-content" v-if="centerProgressSizeDtoList && centerProgressSizeDtoList.length">
          <div v-for="(item,index) in centerProgressSizeDtoList" :key="index">
            <div class="rank-item" >
                <el-popover
                  placement="bottom-start"
                  width="300"
                  trigger="hover"
                  :ref="'popovera'+index"
                  v-if="sliceStr(store.lang === 'zh_CN'?item.info:'')"
                  :content="sliceStr(store.lang === 'zh_CN'?item.info:'')"
                  >
                </el-popover>
                <div class="item-left" :style="store.lang !== 'zh_CN'&& 'cursor:revert'" @click="showCenter(item)" v-popover="'popovera'+index">
                    <div class="item-left-top">
                      <span class="item-name">{{store.lang === 'zh_CN'?item.progressName:item.progressNameEn}}</span>
                      <p class="item-data">
                        <span>{{item.patientSize}}</span>
                      </p>
                    </div>
                    <el-progress
                      color='#2194FE'
                    :percentage="Math.round(item.patientSize/maxNum*100)"
                      :stroke-width="5"
                      :show-text="false"
                    ></el-progress>
                  </div>
                <div v-if="item.pi" :class="['item-right',store.lang === 'zh_CN'?'item-right-ch':'item-right-en']" @click="showPI(item)" >
                  <el-avatar class="item-right-photo" fit="fill" :size="21" :src="item.pi.length >1?'':item.pi[0].avatar">
                    <img src="@/assets/image/photo.png"/>
                  </el-avatar>
                  <span class="item-right-name">{{item.pi.length >1?$t('top.common.investigator'):(store.lang === 'zh_CN'?item.pi[0].realName:item.pi[0].realNameEn)}}</span>
                </div>
                <div v-else  class="item-right"></div>
            </div>
          </div>
        </div>
    </div>
    </el-drawer>
  </div>
</template>
<script>
import {store} from '@/store/index'
export default {
  props: {
    centerProgress: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    maxNum(){
      if(this.centerProgressSizeDtoList[0]){
        return  this.centerProgressSizeDtoList[0].patientSize;
      }else{
        return 165
      }
    }
  },
  data() {
    return {
     centerProgressSizeDtoList: [],
     store,
     drawer:false
    }
  },
  watch: {
    centerProgress: {
      handler (newVal) {
        if(!newVal) return
       this.centerProgressSizeDtoList = [...newVal.centerProgressSizeDtoList]
      },
      deep: true,
      immediate:true
    }
  },
  methods: {
    sliceStr(str) {
      if (!str) return false
      if (str.length < 41) return str.replace(new RegExp("</p>|<p>","g"),"")
      return str.replace(new RegExp("</p>|<p>","g"),"").slice(0,41)+ '...'
    },
    strConvert(val) {
      if(val) {
         return Number(val.substr(0, val.length-1))
      }
    },
    showCenter(item) {
      if (this.store.lang !== 'zh_CN') return
      let title = this.store.lang === 'zh_CN'?item.progressName:item.progressNameEn;
      let info = this.store.lang === 'zh_CN'?item.info:item.infoEn;
      const h = this.$createElement;
      let msg = h('p', {class:'dialog-center'}, [
          info && h('p',{
            domProps:{
            innerHTML:info
          }
          },'',
          )
          ])
      this.$alert(msg, title, {
        customClass:'message-box',
        showConfirmButton:false,
        // confirmButtonText: this.$t('top.common.confirm'),
      });
    },
    showPI(item) {
      const h = this.$createElement;
      let msg =  h('div', {class:'dialog-pi-list'}, item.pi.map(pi => {
        let info = this.store.lang === 'zh_CN'?pi.piInfo:pi.piInfoEn;
        let width= this.store.lang === 'zh_CN'?'300px':'392px';
        return h('div', {class:'dialog-pi',style:`width:${width}`}, [
          pi.avatar && h('img',{attrs:{src:`${pi.avatar}`}},null),
          info && h('div',{
            class:'dialog-pi-content',
            domProps:{
            innerHTML:info
          }
          },'',
          )
        ])
      }
      )
       )
      this.$alert(msg, '', {
        showConfirmButton:false,
        customClass:'dialog-pi-container'
        // confirmButtonText: this.$t('top.common.confirm'),
      });
    }
  }
};
</script>
<style scoped>
.dialog-center p{
  text-indent: 2em;
  text-align: justify;
  line-height: 32px;
}
.dialog-pi-list{
  display: flex;
  flex-wrap: wrap;
  justify-content:space-around;
  max-height: 900px;
  overflow-y:auto;
}
::-webkit-scrollbar {
  width: 6px;
}
::-webkit-scrollbar-thumb {
  background-color: #EBEEF5;
  border-radius: 3px;
}
/* .dialog-pi-list::-webkit-scrollbar {
  display: none;
} */
.dialog-pi {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-bottom: 10px;
  padding:0 5px;
}
.dialog-pi img {
  /* width: 218px; */
  max-width: 230px;
  height: 317px;
  object-fit:cover;
}
.process-container {
  width: 374px;
  height: 356px;
  border-radius: 4px;
  margin-left: 16px;
  box-sizing: border-box;
  height: 100%;
}
.schedule {
  width: 100%;
  line-height: 25px;
  display: flex;
  padding: 12px 22px 12px 24px;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  border-bottom: 1px solid #efefef;
}
.title {
  padding: 0;
  margin: 0;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  font-size: 18px;
  color: #373c48;
}
.check-more {
  min-width: fit-content;
  color: #999999;
  margin-left: 10px;
  text-decoration: none;
  font-size: 12px;
  font-weight: 400;
}
.check-icon {
  padding-left: 5px;
  padding-right: 7px;
  color: #999999;
  font-size: 12px;
  opacity: 0.6;
  position: relative;
}
.check-icon::after {
  position: absolute;
  content: "";
  width: 5px;
  height: 5px;
  border-top: 1px solid #999999;
  border-right: 1px solid #999999;
  transform: rotate(45deg);
  left: 1px;
  top: 6px;
}
.check-icon:hover {
  opacity: 1;
}
.rank-progress {
  margin: 0 13px 31px 19px;
  box-sizing: border-box;
  position: relative;
  height: calc(100% - 85px);
}
.rank-progress-large{
  margin: 0 30px 31px 30px;
}
.rank-progress-large .item-left {
  width: 80%;
}
.rank-title {
  font-weight: 600;
  font-size: 14px;
  color: #333333;
  margin: 18px 0 20px 0;
  text-align: left;
}
.rank-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 0;
}
.item-left{
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
  cursor: pointer;
}
.item-right {
  display: flex;
  align-items: center;
  width: 140px;
  margin-left: 14px;
  border-left: 1px solid #eee;
  padding-left:8px;
  color:#999999;
  font-weight: 400;
  font-size: 12px;
  cursor: pointer;
}
.item-right-en{
  min-width: 137px;
}
.item-right-photo{
  margin-right:2px;
}
.el-avatar /deep/ img{
  width: 100%;
}
.item-right-name{
  text-align: left;
  width:calc(100% - 21px);
  white-space: nowrap;
}
.item-left-top{
  /* display: flex;
  align-items: center;
  justify-content: space-between; */
}
.item-name {
  /* overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; */
  font-size: 12px;
  color: #373c48;
  font-family: PingFangSC-Regular;
}
.item-data {
  text-align: right;
  font-size: 14px;
  color: #2194fe;
  margin:0;
}
.item-total {
  color: #848996 !important;
  margin-right: 8px;
}
.rank-content {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  overflow: hidden;
  overflow-y: auto;
}
.rank-content::-webkit-scrollbar {
  display: none;
}
</style>